import React from 'react'
import { Select } from 'antd'
import { advancedAnalyticsMonthOptions } from '../../../../ResultPanel/Plot/MonthOptions'
import { Label } from "../../../../../common/Label/Label"
import styles from '../../../../ResultPanel/Style/LayoutPanel.module.scss'

interface HistogramAdditionalInputProps {
  variablesY: any[]
  variableY: any
  onVariableYChange: (value: any) => void
  month: any
  onMonthChange: (value: any) => void
  isLoading: boolean
  hasError: boolean
}

export default function HistogramAdditionalInput({
   variablesY,
   variableY,
   onVariableYChange,
   month,
   onMonthChange,
   isLoading,
   hasError
 }: HistogramAdditionalInputProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      gap: '12px',
      height: '100%'
    }}>
      <Label label="Variable Y (Direction)" className={styles.actionItem}>
        <Select
          value={variableY?.Index ? variableY.Index : 0}
          size="small"
          style={{ width: '100%' }}
          onChange={onVariableYChange}
          disabled={isLoading || hasError}
        >
          {variablesY.map((item) => (
            <Select.Option key={item.Index} value={item.Index}>
              {item.Name}
            </Select.Option>
          ))}
        </Select>
      </Label>

      <Label label="Month" className={styles.actionItem}>
        <Select
          value={month}
          size="small"
          style={{ width: '100%' }}
          onChange={onMonthChange}
          options={advancedAnalyticsMonthOptions}
          disabled={isLoading || hasError}
        />
      </Label>

      <div style={{ flex: 1 }} />
    </div>
  )
}
